/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_ClearInputs */

const en_ui_clear = /** @type {(inputs: Ui_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const ar_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const he_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const ur_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const es_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const fr_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const de_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const pt_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const hi_ui_clear = en_ui_clear;

/** @type {(inputs: Ui_ClearInputs) => LocalizedString} */
const bn_ui_clear = en_ui_clear;

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Ui_ClearInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_clear = /** @type {((inputs?: Ui_ClearInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_ClearInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_clear(inputs)
	if (locale === "he") return he_ui_clear(inputs)
	if (locale === "ur") return ur_ui_clear(inputs)
	if (locale === "es") return es_ui_clear(inputs)
	if (locale === "fr") return fr_ui_clear(inputs)
	if (locale === "de") return de_ui_clear(inputs)
	if (locale === "pt") return pt_ui_clear(inputs)
	if (locale === "hi") return hi_ui_clear(inputs)
	if (locale === "bn") return bn_ui_clear(inputs)
	return /** @type {LocalizedString} */ ("Clear")
});